import React from "react";

import FeaturedOneWayContent from "../components/featured-one-way/featured-one-way-content";

const FeaturedOneWay = () => {
  return <FeaturedOneWayContent />;
};

export default FeaturedOneWay;
